import disimg from './images/cross.png';
import ediimg from './images/st5.png';
import enaimg from './images/comp.jpeg';
import axios from "axios";
import { useEffect, useState } from "react";
import SideBar from './sidebar';
import { useNavigate } from 'react-router';

function Users()
{
    let [userData,setUserData]=useState({ulogin:"",upass:"",urole:"",fullname:"",isactive:""});
    let [data,setData]=useState([]);
    let nav=useNavigate();
    function setFormdata(event)
    {
        if(event.target.id=="ulogin")
            setUserData({...userData,ulogin:event.target.value});
        if(event.target.id=="upass")
            setUserData({...userData,upass:event.target.value});
        if(event.target.id=="urole")
            setUserData({...userData,urole:event.target.value});
        if(event.target.id=="fullname")
            setUserData({...userData,fullname:event.target.value});
        if(event.target.id=="chk")
            setUserData({...userData,isactive:event.target.checked?"N":"Y"});
    }
    function loadUserData()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"users.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")    
            {
                setData(reply.data.data);
            }
        });
    }
    async function saveData(event)
    {
        event.preventDefault();
        let config={headers:{"Content-Type":"application/json",}};
        if(window.confirm("Are you sure?"))
        {
            await axios.post(process.env.REACT_APP_APIURL+"users.php?opr=S",JSON.stringify(userData)).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    setUserData({ulogin:"",upass:"",urole:"",fullname:"",isactive:""});
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
        loadUserData();
    }   
    function editUser(ulogin)
    {
        let result=data.filter(e=>e.ulogin==ulogin);
        if(result.length==1)
        {
            result[0].upass="";
            setUserData(result[0]);
        }        
    }
    async function disableUser(ulogin)
    {
        let config={headers:{"Content-Type":"application/json",}};
        if(window.confirm("Are you sure?"))
        {
            let result=data.filter(e=>e.ulogin==ulogin);
            if(result.length==1)
            {
                if(result[0].isactive=="Y")
                    result[0].isactive="N";
                else
                    result[0].isactive="Y";
                await axios.post(process.env.REACT_APP_APIURL+"users.php?opr=U",JSON.stringify(result[0])).then(reply=>
                {
                    if(reply.status==200 && reply.data.status=="OK")
                    {
                        alert(reply.data.message);                        
                    }
                    else
                    {
                        alert(reply.data.message);
                    }
                });
            }
        }
        loadUserData();
    }
    useEffect(()=>{
        if(window.urole.toUpperCase()!="ADMINISTRATOR")
        {
            nav("/dashboard");
        }
        else
        {
            loadUserData();
        }
    },[]);
    return(
       
        <div className="container">
            <div className="mt-3">
                <form onSubmit={saveData}>
                    <div className="card shadow">
                        <div className="card-header text-center bg-primary text-white h5">User Management</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12"></div>
                                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label>Login</label>
                                        <input id="ulogin" onChange={setFormdata} type="text" value={userData.ulogin} className="form-control form-control-sm" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Password</label>
                                        <input id="upass" onChange={setFormdata} type="password" value={userData.upass} className="form-control form-control-sm" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Full Name</label>
                                        <input id="fullname" onChange={setFormdata} type="text" value={userData.fullname} className="form-control form-control-sm" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Role</label>
                                        <select id="urole" onChange={setFormdata} className="form-control form-control-sm" required>
                                            <option value="Administrator" selected={userData.urole=="Administrator"}>Administrator</option>
                                            <option value="User" selected={userData.urole=="User"}>User</option>
                                        </select>
                                    </div>
                                    <div className="form-group mt-2">
                                        <input  id="chk" onChange={setFormdata} type="checkbox" checked={userData.isactive=="N"} /> Disable
                                    </div>
                                    <input type="submit" value="Add/Update User" className="btn btn-primary mt-3" />
                                </div>
                                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12"></div>                                                                
                            </div>
                            
                            <hr/>
                            <div style={{overflow:"auto"}}>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Login</th>
                                            <th>Password</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Last Login</th>
                                            <th>Active</th>
                                            <th>Edit</th>
                                            <th>Enable/Disable</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((e,i)=>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td>{e.ulogin}</td>
                                                <td>********</td>
                                                <td>{e.fullname}</td>
                                                <td>{e.urole}</td>
                                                <td>{e.lastlogin}</td>
                                                <td>{e.isactive}</td>
                                                <td><img onClick={()=>{editUser(e.ulogin)}} src={ediimg} style={{width:'30px',cursor:'pointer'}} /></td>
                                                <td><img onClick={()=>{disableUser(e.ulogin)}} src={e.isactive=="Y"?disimg:enaimg} style={{width:'30px',cursor:'pointer'}} /></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer bg-primary"></div>
                    </div>
                </form>
            </div>
        </div>
        
    );
}
export default Users;